import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { decamelizeKeys } from 'humps';
import { MentoringProgramReflectionSummary, MentoringProgramReflectionQuestionResponse, MentoringProgramReflectionQuestion, MentoringProgramReflectionParticipantResponses } from 'redux/schemas/models/mentoring-program-reflections';

type GetMentoringProgramReflectionSummaryParams = {
  programId: number;
  connectionId: number;
};

export const getMentoringProgramReflectionSummary = createAsyncThunk<
  MentoringProgramReflectionSummary,
  GetMentoringProgramReflectionSummaryParams
>(
  'GET_MENTORING_PROGRAM_REFLECTION_SUMMARY',
  async ({ programId, connectionId }) => {
    const response = await axios.get(`/mentorship_programs/${programId}/connections/${connectionId}/summary`);
    return response.data.result;
  },
);

type GetMentoringProgramReflectionQuestionsParams = {
  programId: number;
  connectionId: number;
};

export const getMentoringProgramReflectionQuestions = createAsyncThunk<
  MentoringProgramReflectionQuestion[],
  GetMentoringProgramReflectionQuestionsParams
>(
  'GET_MENTORING_PROGRAM_REFLECTION_QUESTIONS',
  async ({ programId, connectionId }) => {
    const response = await axios.get(`/mentorship_programs/${programId}/connections/${connectionId}/program_reflection_questions`);
    return response.data.result;
  },
);

type GetMentoringProgramReflectionResponsesParams = {
  programId: number;
  connectionId: number;
};

export const getMentoringProgramReflectionResponses = createAsyncThunk<
  MentoringProgramReflectionParticipantResponses[],
  GetMentoringProgramReflectionResponsesParams
>(
  'GET_MENTORING_PROGRAM_REFLECTION_ANSWERS',
  async ({ programId, connectionId }) => {
    const response = await axios.get(`/mentorship_programs/${programId}/connections/${connectionId}/program_reflection_answers`);
    return response.data.result;
  },
);

type SubmitReflectionResponsesParams = {
  programId: number;
  connectionId: number;
  responses: MentoringProgramReflectionQuestionResponse[];
};

export const submitMentoringProgramReflectionResponses = createAsyncThunk<
  void,
  SubmitReflectionResponsesParams
>(
  'SUBMIT_MENTORING_PROGRAM_REFLECTION_RESPONSES',
  async ({ programId, connectionId, responses: reflectionResponses }, thunkAPI) => {
    await axios.post(
      `/mentorship_programs/${programId}/connections/${connectionId}/program_reflection`,
      decamelizeKeys({ reflectionResponses }),
    );
    await thunkAPI.dispatch(getMentoringProgramReflectionResponses({ programId, connectionId }));
  },
);
